import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

class PaymentMethod extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func
  };

  static propTypes = {
    className             : React.PropTypes.string,
    paymentMethod         : React.PropTypes.object.isRequired,
    includeExpiration     : React.PropTypes.bool,
    includeLeadingBullets : React.PropTypes.bool
  };

  static defaultProps = {
    includeExpiration     : false,
    includeLeadingBullets : false
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let paymentMethod = this.props.paymentMethod;
    let paymentMethodDetails = paymentMethod.details;
    let iconStyle = styles.ccDefault;
    let lastFour = null;
    let expiration = null;
    if(paymentMethod.type === 'apple_pay') {
      iconStyle = styles.ccApplePay;
    } else if(paymentMethod.type === 'android_pay') {
      iconStyle = styles.ccAndroidPay;
    } else {
      let cardType = paymentMethodDetails.type;
      let leadingBullets = this.props.includeLeadingBullets ? '•••• ' : null;
      switch(cardType) {
        case 'Visa':
          iconStyle = styles.ccVisa;
          break;
        case 'American Express':
          iconStyle = styles.ccAmericanExpress;
          break;
        case 'MasterCard':
          iconStyle = styles.ccMasterCard;
          break;
        case 'Discover':
          iconStyle = styles.ccDiscover;
          break;
      }
      lastFour = (
        <span className={styles.lastFour}>{leadingBullets}{paymentMethodDetails.last_four}</span>
      );
    }
    if(this.props.includeExpiration && paymentMethodDetails.expiration_month && paymentMethodDetails.expiration_year) {
      expiration = <span className={styles.ccExpiration}>Exp {paymentMethodDetails.expiration_month}/{paymentMethodDetails.expiration_year.slice(-2)}</span>;
    }
    return (
      <span className={this.props.className}>
        <span className={iconStyle} /> <span className={styles.ccLastFour}>{lastFour}</span>{expiration}
      </span>
    );
  }
}

export default PaymentMethod;



// WEBPACK FOOTER //
// banquet/components/PaymentMethod/index.js